module.exports = __webpack_public_path__ + "img/filtro_seguimiento.8159a54e.png";